import { Controller } from '@hotwired/stimulus';
import { normalize, fuzzyMatch } from '../lib/fuzzy';

// Client-side fuzzy filter for the fillable-form fields list: matches the
// read-only field name and the (editable) description, with a live count,
// clear button and empty state.
export default class extends Controller {
  static targets = ['search', 'clear', 'row', 'count', 'empty'];

  search() {
    const query = normalize(this.searchTarget.value.trim());
    let visible = 0;

    this.rowTargets.forEach((row) => {
      const match = query ? fuzzyMatch(query, normalize(this.rowText(row))) : true;
      row.hidden = !match;
      if (match) visible += 1;
    });

    if (this.hasClearTarget) this.clearTarget.hidden = query.length === 0;
    if (this.hasEmptyTarget) this.emptyTarget.hidden = visible > 0;
    this.updateCount(query, visible);
  }

  clear() {
    this.searchTarget.value = '';
    this.search();
    this.searchTarget.focus();
  }

  rowText(row) {
    const name = row.querySelector('.ds-fillable-name')?.textContent || '';
    const description = row.querySelector('[name$="[description]"]')?.value || '';
    return `${name} ${description}`;
  }

  updateCount(query, visible) {
    if (!this.hasCountTarget) return;

    const data = this.countTarget.dataset;
    this.countTarget.textContent = query
      ? (data.filtered || '').replace('COUNT', visible)
      : (data.all || '');
  }
}
